import { atom } from 'jotai';

const results = atom({
    key: 'resultsState',
    default: []
});

export default results;
